import AppConstants from '../../Constants/AppConstants';

export const subscriptionDraftKey = subscriptionId =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:subscription:${subscriptionId || 'new'}`;

export const subscriptionConfigDraftKey = () =>
  `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:subscription-config:v1`;

export const readSubscriptionDraft = key => {
  if (typeof window === 'undefined') return {};
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' && !Array.isArray(draft) ? draft : {};
  } catch (error) {
    return {};
  }
};

export const writeSubscriptionDraft = (key, values) => {
  if (typeof window === 'undefined') return;
  const draft = {
    title: String(values.title || '').slice(0, 300),
    description: String(values.description || '').slice(0, 4000),
    amount: String(values.amount ?? '').slice(0, 40),
    sku: String(values.sku || '').slice(0, 100),
    image_path: {value: String(values.image_path?.value || (typeof values.image_path === 'string' ? values.image_path : '')).slice(0, 2000)},
    allowed_listings: String(values.allowed_listings ?? '').slice(0, 40),
    fee_fixed_per_order: String(values.fee_fixed_per_order ?? '').slice(0, 40),
    commission_percent_per_order: String(values.commission_percent_per_order ?? '').slice(0, 40),
    currency_id: values.currency_id ?? null,
    expiry_days: String(values.expiry_days ?? '').slice(0, 40),
    type: String(values.type || '').slice(0, 40),
    active: Boolean(values.active),
  };
  try { window.localStorage.setItem(key, JSON.stringify(draft)); }
  catch (error) { /* Keep the editor usable if browser storage is unavailable. */ }
};

export const readSubscriptionConfigDraft = key => {
  if (typeof window === 'undefined') return {};
  try {
    const draft = JSON.parse(window.localStorage.getItem(key) || '{}');
    return draft && typeof draft === 'object' && !Array.isArray(draft) ? draft : {};
  } catch (error) {
    return {};
  }
};

export const writeSubscriptionConfigDraft = (key, values) => {
  if (typeof window === 'undefined') return;
  const draft = {
    switchValue: Boolean(values.switchValue),
    message: String(values.message || '').slice(0, 2000),
    purchasedMessage: String(values.purchasedMessage || '').slice(0, 2000),
    listingExhaustedmessage: String(values.listingExhaustedmessage || '').slice(0, 2000),
    selectedTypeValue: String(values.selectedTypeValue || '').slice(0, 80),
  };
  try { window.localStorage.setItem(key, JSON.stringify(draft)); }
  catch (error) { /* Keep the editor usable if browser storage is unavailable. */ }
};

export const clearSubscriptionDraft = key => {
  if (typeof window === 'undefined') return;
  try { window.localStorage.removeItem(key); }
  catch (error) { /* Ignore storage errors after save or explicit discard. */ }
};
